import styled from "styled-components";

const ReverseContent = () => {
    return (
        <ContentContainer>
            <ContentHeader>
                Reverse Mortgages: Accessing the Equity You've Built
            </ContentHeader>
            <ContentParagraph>
                If you’re 62 or older and own your home, a reverse mortgage may allow you to convert a portion of your home equity into loan funds—without having to sell your home or make regular monthly mortgage payments.*
            </ContentParagraph>
            <ContentParagraph>
                The borrower must meet all loan obligations, including living in the property as the principal residence and paying property charges such as property taxes, fees, and hazard insurance. The borrower must maintain the home. If these obligations are not met, the loan will need to be repaid.
            </ContentParagraph>
            <hr />
            <ContentHeader>
                How Reverse Mortgage Funds Can Be Accessed
            </ContentHeader>
            <ContentParagraph>
                Reverse mortgages offer several flexible payout options, allowing you to use your home equity in a way that supports your retirement needs:
            </ContentParagraph>
            <ul>
                <li>Lump Sum – Receive a one-time payment at closing, which may help with larger expenses or pay off higher-interest credit card debt</li>
                <li>Monthly Disbursements – Access loan funds on a regular basis to help with ongoing costs and personal budgeting</li>
                <li>Line of Credit – Draw funds as needed, with the added potential for the available credit to grow over time</li>
                <li>Blended Option – Combine a line of credit with monthly disbursements or a partial lump sum, depending on your financial goals</li>
            </ul>
            <hr />
            <ContentHeader>
                Support Your Retirement with Greater Flexibility
            </ContentHeader>
            <ContentParagraph>
                A reverse mortgage provides access to loan proceeds tied to your home equity. These funds can help manage healthcare expenses, home repairs, or other unplanned costs—giving you more flexibility in your retirement years.
            </ContentParagraph>
            <hr />
            <ContentHeader>
                Stay in the Home You Love While Accessing Its Value
            </ContentHeader>
            <ContentParagraph>
                A reverse mortgage allows eligible homeowners 62 and older to access a portion of their home equity without having to sell or move. You maintain ownership and stay in your home,* while using the loan funds to help with retirement expenses or other financial needs.
            </ContentParagraph>
            <ContentParagraph>
                The right to remain in the home is contingent on the borrower continuing to pay property taxes, homeowners insurance, maintain the property, and comply with all loan terms.
            </ContentParagraph>
            <hr />
            <ContentHeader>
                Take the Next Step
            </ContentHeader>
            <ContentParagraph>
                Wondering if a reverse mortgage could be part of your retirement needs? Click below to learn more and see how much you may be eligible to receive.
            </ContentParagraph>
            <ContentParagraph>
                <button
                    href="#"
                    style={{
                        color: "#007bff",
                        textDecoration: "underline",
                        cursor: "pointer",
                        fontSize: "1rem",
                        marginBottom: "1rem",
                        border: "none",
                        background: "none",
                        padding: 0
                    }}
                    onClick={() => {
                        window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                >
                    Get My Free Reverse Mortgage Estimate
                </button>
            </ContentParagraph>
            <hr />
            <ContentHeader>
                Required Disclaimers
            </ContentHeader>
            <ContentHeaderH3>
                Reverse Mortgage Product Disclaimer
            </ContentHeaderH3>
            <ContentParagraph>
                The borrower must meet all loan obligations, including living in the property as the principal residence and paying property charges, including property taxes, fees, and hazard insurance. The borrower must maintain the home. If the homeowner does not meet these loan obligations, then the loan will need to be repaid.
            </ContentParagraph>
            <ContentHeaderH3>
                Government Disclaimer
            </ContentHeaderH3>
            <ContentParagraph>
                These materials were not provided by HUD or FHA and were not approved by FHA or any government agency.
            </ContentParagraph>
            <ContentHeaderH3>
                Advertising Disclosure
            </ContentHeaderH3>
            <ContentParagraph>
                RateZip collects and transfers your information to complete your request and is compensated by the providers that receive your information. By submitting your request you agree to RateZip's Privacy Policy. View Peklava LLC DBA RateZip Licenses.
            </ContentParagraph>
        </ContentContainer>
    );
}

const ContentContainer = styled.div`
    background-color: white;
    border-radius: 1rem;
    width: 85%;
    max-width: 1000px;
`;

const ContentHeader = styled.h2`
    font-size: 1.75rem;
    margin-top: 0;
    margin-bottom: 0.5rem;
    font-weight: 500;
    line-height: 1.2;
`;

const ContentParagraph = styled.p`
    margin: 2rem auto;
    line-height: 1.8rem;
`;

const ContentHeaderH3 = styled.h3`
    font-size: 1.5rem;
`;

export default ReverseContent